import { render, staticRenderFns } from "./agb.vue?vue&type=template&id=110ebf2b&scoped=true&"
import script from "./agb.vue?vue&type=script&lang=js&"
export * from "./agb.vue?vue&type=script&lang=js&"
import style0 from "./agb.vue?vue&type=style&index=0&id=110ebf2b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ebf2b",
  null
  
)

export default component.exports